// Libs
import { useFormContext } from 'react-hook-form';

// RDS
import FormField from '@ramsey-design-system/form-field';
import Heading from '@ramsey-design-system/heading';
import Textarea from '@ramsey-design-system/textarea';

// Components
import WorkshopStepNavigation from '../WorkshopStepNavigation';

// Types
import { WorkshopFormValues } from '../types';

function WorkshopNotes() {
  const { register } = useFormContext<WorkshopFormValues>();

  return (
    <section>
      <Heading level="2" className="text-6 mb-3">
        Workshop Notes
      </Heading>

      <FormField className="mb-3" label="Additional Notes" note="(optional)">
        {(props) => (
          <Textarea
            {...props}
            {...register('additionalNotes')}
            data-testid="workshop-notes-input"
            rows={5}
            placeholder="Anything your attendees or co-facilitators should know - parking, location notes, materials to bring, etc."
            className="w-full"
          />
        )}
      </FormField>

      <WorkshopStepNavigation />
    </section>
  );
}

export default WorkshopNotes;
